module.exports = __webpack_public_path__ + "images/landing/video-previews/success_preview_2_981_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/success_preview_2_981_2x.jpg
// module id = WpQJ
// module chunks = 1